.sbbIcon {
  position: relative;
  user-select: none;

  &.clickable {
    cursor: pointer;
  }

  .circle {
    left: 0;
    position: absolute;
    height: 100%;
    width: 100%;
  }

  .icon {
    left: 0;
    position: absolute;
    height: 100%;
    width: 100%;
  }

  &.circled {
    .icon {
      top: calc(50% * (1 - 24 / 34));
      left: calc(50% * (1 - 24 / 34));
      height: calc(100% * (24 / 34));
      width: calc(100% * (24 / 34));
    }
  }
}
